import {
  findFontWeightAndStyleKeyByValue,
  fontWeightAndStyleKeys,
  fontWeightAndStyleLabels,
  fontWeightAndStyleValues,
} from '@email-editor/ui'
import { FormSelect, FormSelectDataType } from '@systemeio/ui'
import Option from '../../components/Option'

const options: FormSelectDataType<string>[] = Object.keys(fontWeightAndStyleKeys).map(fontKey => ({
  id: fontWeightAndStyleValues[fontKey],
  caption: fontWeightAndStyleLabels[fontKey],
}))

type FontWeightAndStyleProps = {
  label?: string
  update: (value: string) => void
  value?: string
}

function FontWeightAndStyle({
  label = 'settings_options.font_weight.label',
  update,
  value,
}: FontWeightAndStyleProps) {
  const fontKey = value && findFontWeightAndStyleKeyByValue(value)

  return (
    <Option label={label}>
      <FormSelect
        value={fontKey}
        data={options}
        onChange={option => {
          if (option) {
            update(option)
          }
        }}
        withoutCloseIcon
      />
    </Option>
  )
}

export default FontWeightAndStyle
